import './Placeholder.css';
import Icon from './Icon';

export default function Placeholder({
  label,
  aspect = '3 / 4',
  id,
  className = '',
  dark = false,
  icon = null,
  frame = 'panel',
  src = null,
  alt = '',
  objectPosition,
}) {
  const frameClass = frame !== 'panel' ? `placeholder--${frame}` : '';
  const photoClass = src ? 'placeholder--photo' : '';
  return (
    <div
      id={id}
      className={`placeholder ${dark ? 'placeholder--dark' : ''} ${frameClass} ${photoClass} ${className}`.trim().replace(/\s+/g, ' ')}
      style={{ aspectRatio: aspect }}
      role="img"
      aria-label={src ? alt || label : label}
    >
      {src ? (
        <img
          className="placeholder__img"
          src={src}
          alt={alt || label}
          loading="lazy"
          style={objectPosition ? { objectPosition } : undefined}
        />
      ) : (
        <div className="placeholder__inner">
          <span className="placeholder__monogram" aria-hidden="true">W</span>
          {icon && (
            <span className="placeholder__icon" aria-hidden="true">
              <Icon name={icon} size={30} />
            </span>
          )}
          <span className="placeholder__label">{label}</span>
        </div>
      )}
    </div>
  );
}
